// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1a3V7","info":"UpdateTermsInfo_info__23ccJ"};